import React from "react"
import { FormControl } from "react-bootstrap"
import InputMask from "react-input-mask"

import Button from "../../../../../_components/Button"
import Text from "../../../../../_components/Text"
import Modal from "../../../../../_components/Modal"
import StateLocation from "../../../../../_components/Address/StateLocation"
import CityLocation from "../../../../../_components/Address/CityLocation"

import { createTransporter, updateTransporter } from "../../../../../api/nfe"
import { showSnackBar } from "../../../../../utils"

export default props => {
    const ref = React.useRef()
    const [title, setTitle] = React.useState("Cadastrar Transportadora")
    const [buttonTitle, setButtonTitle] = React.useState("Cadastrar Transportadora")
    const [loading, setLoading] = React.useState(false)
    const [show, showModal] = React.useState(false)
    const [data, setData] = React.useState({})

    const [type, setType] = React.useState(1)

    function onChange({ target }) {
        const { name: key, value } = target
        setData({
            ...data,
            [key]: value
        })

        if (key === "name") {

            setData({
                ...data,
                name: value.replace(/[^a-zA-Z0-9 ]/g, ''),
            })
        }

        if (key === "state_registry") {

            setData({
                ...data,
                state_registry: value.replace(/\D/g, ''),
            })
        }
    }

    function onHide() {
        showModal(false)
        if (props.onHide) {
            props.onHide()
        }
    }

    function onChangellType(e) {
        setType(parseInt(e.target.value))
    }

    function setStateLocation(state) {
        const nd = { ...data }
        nd["state_location"] = state.id
        nd["uf_code"] = state.uf_code
        nd["city_location"] = ''
        nd["city_name"] = ''
        setData(nd)
    }

    function setCityLocation(city) {
        const nd = { ...data }
        nd["city_location"] = city.id
        setData(nd)
    }

    function onSave() {
        setLoading(true)
        if (data.cpf_cnpj) {
            data.cpf_cnpj = data.cpf_cnpj.replace(/\D/g, '')
        }
        const request = data.id ? updateTransporter : createTransporter

        request(data).then(resp => {
            showSnackBar(`${data.id ? "A Transportadora foi atualizada" : "A Transportadora foi cadastrada!"}`, "success")
            if (props.onCreate) {
                props.onCreate(resp)
            }
        })
            .catch(error => {
                let errors = []
                if (error.city_location) {
                    errors.push("Informe a cidade")
                }
                if (error.cpf_cnpj) {
                    errors.push("Informe o CPF ou CNPJ")
                }
                if (error.name) {
                    errors.push("Informe o nome")
                }
                if (error.state_location) {
                    errors.push("Informe o Estado")
                }
                if (error.cpf_cnpj_error) {
                    errors.push("Este documento já está cadastrado")
                } if (error.street) {
                    errors.push("Informe o endereço da transportadora")
                }
                if (error.state_registry) {
                    errors.push("Informe a Inscrição Estadual")
                }
                showSnackBar(errors.join(", "))
            })
            .finally(() => {
                setTimeout(() => setLoading(false), 3000)
            })
    }

    function handleOpenModal() {
        if (props.show === true) {

            let adaptedData = { ...props.data }
            adaptedData.cpf_cnpj = props.data.cpf || props.data.cnpj
            if (props.data.city_location && props.data.state_location) {
                adaptedData.city_location = props.data.city_location.id
                adaptedData.city_name = props.data.city_location.city_name
                adaptedData.state_location = props.data.state_location.id
                adaptedData.state_name = props.data.state_location.state_name
            }
            if (adaptedData.cpf_cnpj) {
                setType(adaptedData.cpf_cnpj.length === 11 ? 1 : 2)
            }
            setData(adaptedData)
            setTitle("Atualizar Transportadora")
            setButtonTitle("Atualizar Transportadora")
        } else {
            setType(1)
            setData({})
        }
    }
    React.useEffect(handleOpenModal, [props.show])

    return <div ref={ref}>
        <Button onClick={() => showModal(true)}>
            {buttonTitle}
        </Button>

        <Modal
            title={title}
            show={show || props.show}
            onHide={onHide}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Tipo de transportadora
                                </Text>
                            </div>
                            <FormControl
                                disabled={loading}
                                as="select"
                                onChange={onChangellType}>
                                <option
                                    selected={type === 1}
                                    value={1}>
                                    Pessoa Física
                                </option>
                                <option selected={type === 2} value={2}>
                                    Pessoa Jurídica
                                </option>
                            </FormControl>
                        </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Informe {
                                        type === 1 ? "o nome " : "a Razão Social "
                                    }
                                    da transportadora
                                </Text>
                            </div>
                            <FormControl
                                name="name"
                                onChange={onChange}
                                disabled={loading}
                                value={data["name"]} />
                        </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Informe o {type === 1 ? "CPF" : "CNPJ"}
                                </Text>
                            </div>
                            <InputMask
                                name="cpf_cnpj"
                                value={data.cpf_cnpj}
                                onChange={onChange}
                                disabled={loading}
                                className="form-control"
                                mask={type === 1 ? "999.999.999-99" : "99.999.999/9999-99"} />
                        </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Informe a Inscrição Estadual (IE)
                                </Text>
                            </div>
                            <FormControl
                                disabled={loading}
                                name="state_registry"
                                value={data.state_registry}
                                onChange={onChange} />
                        </div>
                    </div>
                    <div className="col-12">

                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Endereço
                                </Text>
                            </div>
                            <FormControl
                                disabled={loading}
                                name="street"
                                value={data.street}
                                onChange={onChange} />
                        </div>
                    </div>
                    <div className="col-6"></div>
                    <div className="col-md-6 col-xs-12">
                        <StateLocation
                            disabled={loading}
                            selected={data.state_name}
                            onChange={setStateLocation} />
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <CityLocation
                            disabled={loading}
                            onSelectCity={setCityLocation}
                            stateCode={data.uf_code}
                            defaultInputValue={data.city_name} />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <Button
                    disabled={loading}
                    onClick={onSave}>
                    {
                        loading
                            ? "Carregando ..."
                            : buttonTitle
                    }
                </Button>
            </div>
        </Modal>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Transport/CreateTranporter/index.jsx